import { computed, Ref, ref } from 'vue'
import { useStore } from 'vuex'

export const boundaryConditionMixin = (storeNamespace: string, tableRef: Ref<HTMLDivElement>) => {
  const dialog = ref(false)
  const downloadDialog = ref(false)
  const exportDialog = ref(false)
  const writeLoading = ref(false)
  const fetchLoading = ref(false)

  const store = useStore()

  const count = computed(() => store.state[storeNamespace].count)
  const options = computed(() => store.state[storeNamespace].options)
  const pagination = computed(() => store.state[storeNamespace].pagination)
  const loadingItems = computed(() => store.state[storeNamespace].loading)
  const downloadLoading = computed(() => store.state[storeNamespace].downloadLoading)
  const exportLoading = computed(() => store.state[storeNamespace].exportLoading)
  const items = computed(() => store.state[storeNamespace].items)
  const importItems = computed(() => store.state[storeNamespace].importItems)
  const ignoredReferencePoint = computed(() => store.state[storeNamespace].ignoredReferencePoint)

  const importItemCount = computed(() => importItems.value.length)
  const loading = computed(() => loadingItems.value || fetchLoading.value)
  const templateFileName = computed(() => store.state[storeNamespace]['templateFileName'])
  const exportFileName = computed(() => store.getters[storeNamespace + '/getExportFileName'])
  const years = computed(() => store.state[storeNamespace]['years'])
  const importedYears = computed(() => store.state[storeNamespace]['importedYears'])

  const fetchPaginated = async () => store.dispatch(storeNamespace + '/fetchPaginated')
  const fetchYears = async () => store.dispatch(storeNamespace + '/fetchYears')
  const fetchAvailableReferencePoints = async () =>
    store.dispatch(storeNamespace + '/fetchAvailableReferencePoints')
  const fetchOptions = async () => store.dispatch(storeNamespace + '/fetchOptions')

  const changePaginatedPage = async () => {
    await fetchPaginated()
  }

  const downloadTemplate = async () => store.dispatch(storeNamespace + '/downloadTemplate')
  const exportData = async () => store.dispatch(storeNamespace + '/exportData')

  const addNewItem = async () => store.dispatch(storeNamespace + '/addNewItem')

  const update = async () => store.dispatch(storeNamespace + '/update')
  const create = async () => store.dispatch(storeNamespace + '/create')
  const emptyDirtyItems = () => store.dispatch(storeNamespace + '/emptyDirtyItems')

  const saveChanges = async () => {
    writeLoading.value = true
    try {
      await update()
      await create()
      emptyDirtyItems()
      if (tableRef.value && 'dirtyItems' in tableRef.value) {
        tableRef.value.dirtyItems = []
      }
    } catch (e) {
      writeLoading.value = false
    }
    writeLoading.value = false
  }

  return {
    dialog,
    options,
    downloadDialog,
    exportDialog,
    writeLoading,
    fetchLoading,
    count,
    pagination,
    loadingItems,
    downloadLoading,
    exportLoading,
    items,
    importItems,
    ignoredReferencePoint,
    importItemCount,
    loading,
    templateFileName,
    exportFileName,
    years,
    importedYears,
    addNewItem,
    fetchPaginated,
    fetchYears,
    fetchAvailableReferencePoints,
    fetchOptions,
    changePaginatedPage,
    downloadTemplate,
    exportData,
    saveChanges
  }
}
